const sizeConfigs = {
  sidebar: {
    width: "200px"
  }
};

export default sizeConfigs;